// App utils
import { datajs } from '../shared/utils';
import { Modal } from 'bootstrap';
import lottie from 'lottie-web';
// import html2pdf from 'html2pdf.js';
// import CaseGallerySlider from './caseGallerySlider';
import { initGlobalCaseGallery } from './casePhotoswipeGallery';

export default class ActionMenu {
	static init() {
		const themeUrl = window.AppGlobals.themeUrl;
		const copyLinkBtn = datajs('action-copy-link');
		const textCopiedModalElement = datajs('text-copied');
		const checkmarkAnimationElement = datajs('checkmark-animation');
		const shareToolbar = datajs('share-toolbar');
		const shareToolbarToggleBtn = datajs('toggle-share-toolbar');
		let textCopiedModal = false;

		// const downloadPdfBtn = datajs('action-download-pdf');
		// const pdfGeneratingModalElement = datajs('pdf-generating');
		// const pdfGeneratingAnimationElement = datajs('pdf-generating-animation');
		// const lazyImages = document.querySelectorAll('img.lazyload');

		// let pdfGeneratingModal = false;
		// let lottieAnimation = null;

		const copyLink = () => {
			// Copy link to clipboard
			navigator.clipboard?.writeText(window.location.href).then(() => {
				// Modal visibility
				textCopiedModal.show();

				const lottieAnimation = lottie.loadAnimation({
					container: checkmarkAnimationElement,
					renderer: 'svg',
					loop: false,
					autoplay: true,
					path: `${themeUrl}/assets/images/checkmark-animation.json`,
				});

				// Hide the modal after the lottie amimation has completed
				lottieAnimation.addEventListener('complete', () => {
					setTimeout(() => textCopiedModal.hide(), 500);
				});

				// Destroy the lottie animation after the modal is hidden
				textCopiedModalElement.addEventListener('hidden.bs.modal', () => {
					lottieAnimation.destroy();
				});
			});

			return false;
		};

		// Copy link
		if (navigator.clipboard && textCopiedModalElement) {
			textCopiedModal = new Modal(textCopiedModalElement);
			copyLinkBtn?.addEventListener('click', copyLink);
		} else {
			copyLinkBtn?.classList.add('d-none');
		}

		const toggleShareToolbar = (e) => {
			e.preventDefault();
			shareToolbarToggleBtn.classList.toggle('is-active');
			shareToolbar.classList.toggle('is-active');
		};

		// Share toolbar
		shareToolbarToggleBtn?.addEventListener('click', toggleShareToolbar);

		/*
		const deactivateCSSForPDF = () => document.documentElement.classList.remove('pdf');
		const activateCSSForPDF = () => document.documentElement.classList.add('pdf');

		const createPdf = () => {
			const element = document.getElementById('main-content');
			lottieAnimation = lottie.loadAnimation({
				container: pdfGeneratingAnimationElement,
				renderer: 'svg',
				loop: true,
				autoplay: true,
				path: `${themeUrl}/assets/images/pdf-generating-animation.json`,
			});

			html2pdf()
				.from(element)
				.set({
					margin: [10, 0],
					pagebreak: { mode: 'css' },
					html2canvas: {
						scale: 2,
						windowWidth: 1280,
						windowHeight: 1780,
						logging: false,
						ignoreElements: (element) => {
							// Ignore buttons and videos
							if (
								element.tagName === 'BUTTON' ||
								element.tagName === 'VIDEO' ||
								element.tagName === 'IFRAME' ||
								element.classList.contains('btn') ||
								element.classList.contains('modal')
							) {
								return true;
							}
						},
					},
					jsPDF: { compress: true },
				})
				.save(`${slugify(document.title)}.pdf`)
				.finally(() => {
					setTimeout(() => pdfGeneratingModal.hide(), 1000);
				});
		};


		const downloadPdf = () => {
			const swiperInstance = datajs('case-gallery-slider');
			downloadPdfBtn.disabled = true;

			// Activate modal
			pdfGeneratingModal.show();

			// Destroy swiper instance
			if (swiperInstance !== undefined) {
				swiperInstance?.swiper.destroy(false, true);
			}

			// Apply PDF CSS-styling
			activateCSSForPDF();

			// Create the actual PDF
			createPdf();
		};

		// Download PDF
		/*
		if (pdfGeneratingModalElement) {
			pdfGeneratingModal = new Modal(pdfGeneratingModalElement);
			downloadPdfBtn?.addEventListener('click', downloadPdf);

			// Unveil images further down in the document
			lazyImages.forEach((image) => {
				image.classList.add('lazypreload');
			});

			// Wait before showing the download button
			// Todo: Use a reliable event for this instead. (That works with the lazyloading)
			setTimeout(() => {
				downloadPdfBtn.classList.remove('d-none');
			}, 5000);

			// Reset document when modal is hidden
			pdfGeneratingModalElement.addEventListener('hidden.bs.modal', () => {
				lottieAnimation.destroy();
				deactivateCSSForPDF();
				downloadPdfBtn.disabled = false;
				CaseGallerySlider.init();
			});
		}
		*/

		// Case Gallery
		initGlobalCaseGallery();
	}
}
